<app-nav></app-nav>
<section class="login-section">
    <div class="container">
      <div class="product-container">
        <div class="product-inner">
          <div class="text-center top-gap-md">
            <p class="note">A SMS with 4 digits verification code has been sent to +91 Optional("{{otpMobile}}")</p>
          </div>
          <div class="text-center top-gap-md">
            <p class="note">To verify your account enter and submit the code</p>
          </div>
          <form name="form" (ngSubmit)="otpForm.form.valid" #otpForm="ngForm" >
            <div class="input-group mb-3 input-mobile">
                <input type="text" #otp="ngModel" name="otp" id="otp" class="form-control" placeholder="Verification Code" (keypress)="keyPress($event)" minlength=4 maxlength=4 [(ngModel)]="data.otp" required>
            </div>
            <div class="form-group">
              <div *ngIf="otp.invalid && (otp.dirty || otp.touched)" class="alert alert-danger">
                <div *ngIf="otp.errors.required">
                    Please enter OTP
                </div>
                <div *ngIf="otp.errors.minlength">
                    Enter 4 digits OTP
                </div>
              </div>
            </div>
            <div class="form-group">
                <span [innerHtml]="error" class="error"></span>
            </div>
            <div class="text-center">
                <p class="note">You need to do this verification only once</p>
              </div>
              <div class="row top-gap-lg">
                  <div class="col">
                    <button class="btn btn-reset btn-primary" (click)="resendOTP()">Resend</button>
                  </div>
                  <div class="col">
                    <button class="btn btn-reset btn-primary" [disabled]="otpForm.form.invalid" (click)="verifyOTPNumber()">Submit</button>
                  </div>
              </div>
          </form>
        </div>
      </div>
    </div>
  </section>